import React from "react";
import { IconButton } from "@mui/material";
import { Equalizer, Menu } from "@mui/icons-material";

import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";

import useStyles from "./styles";
import { Colors } from "@/theme";

const SwitchButtons = ({ isChart, onSwitch }) => {
  return (
    <ToggleButtonGroup
      // sx={{ backgroundColor: Colors.GREEN_LIGHT }}
      value={isChart}
      exclusive
      onChange={(e, value) => onSwitch(value)}
    >
      <ToggleButton
        sx={{
          padding: "2px 10px",
          "&.Mui-selected": {
            backgroundColor: isChart ? Colors.GREEN_LIGHT : Colors.WHITE,
          },
        }}
        value={true}
      >
        <Equalizer
          fontSize="large"
          sx={{ color: isChart ? Colors.GREEN : Colors.GREEN_128 }}
        />
      </ToggleButton>
      <ToggleButton
        sx={{
          padding: "2px 10px",
          "&.Mui-selected": {
            backgroundColor: !isChart ? Colors.GREEN_LIGHT : Colors.WHITE,
            borderLeft: "1px solid rgba(0, 0, 0, 0.12)",
          },
        }}
        value={false}
      >
        <Menu
          fontSize="large"
          sx={{ color: !isChart ? Colors.GREEN : Colors.GREEN_128 }}
        />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default SwitchButtons;
